
export enum ClientEventType {
    ACCOUNT_APPLICATION_SUBMITTED = "ACCOUNT_APPLICATION_SUBMITTED",
    ACHIEVEMENT_UNLOCKED = "ACHIEVEMENT_UNLOCKED",
    BROKER_STATE_CHANGED = "BROKER_STATE_CHANGED",
    DASHBOARD_CONFIGURATION_UPDATED = "DASHBOARD_CONFIGURATION_UPDATED",
    DIVIDENDS_UPDATED = "DIVIDENDS_UPDATED",
    ORDER_CREATED = "ORDER_CREATED",
    ORDER_UPDATED = "ORDER_UPDATED",
    ORDER_COMPLETED = "ORDER_COMPLETED",
    PORTFOLIO_UPDATED = "PORTFOLIO_UPDATED",
    POSITIONS_LOADED = "POSITIONS_LOADED",
    RISK_SUMMARIES_UPDATED = "RISK_SUMMARIES_UPDATED",
    SECURITY_INFO_UPDATED = "SECURITY_INFO_UPDATED",
    SESSION_UPDATED = "SESSION_UPDATED",
    SPAN_MODEL_UPDATED = "SPAN_MODEL_UPDATED",
    WATCHLIST_CHANGED = "WATCHLIST_CHANGED"
}
